import { useEffect } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../assets/svg/sort';
import { Button } from '../../../../../components/button/button';
import { DropdownFilter } from '../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { ManagerPath, RootPath, TreesPath } from '../../../../../routes/manager/manager-enums';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import s from './tree-controls.module.css';

export const TreeControls = () => {
  const { t, getLocale } = useLang();
  const { place, fetchBranches } = useBranchesStore();

  useEffect(() => {
    fetchBranches({ since_id: 0, n: 1000, is_by_company: true });
  }, []);

  return (
    <div className={s.feature}>
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Больше привязанных QR'), value: 'qr', dir: 'asc' },
          { label: t('Меньше привязанных QR'), value: 'qr', dir: 'desc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По названию'),
            value: 'name',
            filter: 'input',
          },
          {
            label: t('По описанию'),
            value: 'description',
            filter: 'input',
          },

          {
            label: t('По филиалам'),
            value: 'branch',
            filter: 'single-select',
            filterOptions: place?.map((item) => ({
              id: String(item.id),
              value: getLocale(item.name),
            })),
          },
        ]}
      />

      <HasAccess service="tree" permissions={['write']}>
        <Link
          to={concatPath([RootPath.Manager, ManagerPath.Trees, TreesPath.CreateTree])}
          data-testid="button-create-tree"
        >
          <Button fullWidth size="lg">
            <AiOutlinePlus />
            <span className="hide__M">{t('Создать дерево')}</span>
          </Button>
        </Link>
      </HasAccess>
    </div>
  );
};
